import React, { FC } from 'react'
import { Button, IconButton } from '@mui/material'
import { ModalRoute } from '@lib/Layout/ModalRoute'
import { ISubmissionQueryParam } from '@shared/Services/QueryParamService'
import ListAltIcon from '@mui/icons-material/ListAlt'
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined'

interface ILinkProps {
  routeKey: string
  query?: ISubmissionQueryParam
}

export const BtnDetail: FC<ILinkProps> = (props) => (
  <IconButton color='info' onClick={() => ModalRoute.show({ routeKey: props.routeKey, query: props.query })}>
    <ListAltIcon />
  </IconButton>
)

interface IBtnSettingProps {
  routeKey: string
}

export const BtnSetting: FC<IBtnSettingProps> = (props) => (
  <Button
    variant='contained'
    color='primary'
    size='small'
    startIcon={<SettingsOutlinedIcon />}
    sx={{ minWidth: '110px' }}
    onClick={() => ModalRoute.show({ routeKey: props.routeKey })}
  >
    Settings
  </Button>
)
